"use client";

import { usePathname, useRouter } from "next/navigation";
import Frontpage from "@/components/pages/Frontpage";
import CreateGame from "@/components/pages/CreateGame";
import SelectPlayer from "@/components/pages/SelectPlayer";

export default function Game() {
  const pathname = usePathname();
  const router = useRouter();
  const segments = pathname.split("/").filter(Boolean);

  // Parse the URL structure
  const [route, gameId, playerId] = segments;

  switch (route) {
    case "create-game":
      return <CreateGame />;
    case "game":
      // No gameId
      if (!gameId) {
        return <Frontpage />;
      }
      // No playerId
      if (!playerId) {
        return <SelectPlayer gameId={parseInt(gameId)} />;
      }

      // If we have both gameId and playerId, the nested routes will handle it
      // This shouldn't actually render because the nested routes take precedence
      return null;
    default:
      return <Frontpage />;
  }
}
